import React, { useState, useRef, useEffect } from 'react';

// সাধারণ HTML <datalist> ব্রাউজারভেদে টাইপ করা লেখা অনুযায়ী ঠিকমতো ফিল্টার করে না
// (কোথাও পুরো লিস্ট দেখিয়ে দেয়) -- তাই এখানে নিজের মতো করে ফিল্টার করা একটা
// সাজেশন-বক্স বানানো হয়েছে, যেটা সবসময় নির্ভরযোগ্যভাবে সাবস্ট্রিং ম্যাচ করবে।
const AutocompleteInput = ({ value, onChange, onSelect, options, placeholder, className }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const typed = (value || '').toLowerCase().trim();
  const filtered = typed
    ? options.filter((opt) => opt && opt.toLowerCase().includes(typed)).slice(0, 50)
    : options.slice(0, 50);

  return (
    <div ref={wrapRef} style={{ position: 'relative', marginBottom: '15px' }}>
      <input
        value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        className={className}
        style={{ marginBottom: 0 }}
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, background: '#fff',
          border: '1px solid #ddd', borderRadius: '10px', maxHeight: '220px',
          overflowY: 'auto', zIndex: 50, boxShadow: '0 8px 20px rgba(0,0,0,0.12)'
        }}>
          {filtered.map((opt, i) => (
            <div
              key={i}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => { (onSelect || onChange)(opt); setOpen(false); }}
              style={{ padding: '9px 15px', cursor: 'pointer', fontSize: '14px', borderBottom: i < filtered.length - 1 ? '1px solid #f5f5f5' : 'none' }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#f4f7fe'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AutocompleteInput;
